A page of hirers that have an active relationship with the requesting partner.

This will not return agencies; it's not possible to have a relationship with an agency.

A maximum of 100 hirers can be returned in a single page.
Additional hirers can be queried using a pagination cursor.

The result list is ordered alphabetically by the hirer's name.

This query accepts browser tokens that include the `query:organizations` scope.
It will only return the single hirer that the browser token is scoped to.
